import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterComplex } from 'src/app/shared/models/filtercomplex.model';
import { APISCockpit } from 'src/service/apis-cockpit';
import { ComponentesUtils } from 'src/utils/components-utils';
import { TaskItem } from '../taskcommon/taskcommon.class';
import { TaskInput } from './taskinput';

const API = '/api/construction-projects/v1/cockpit-taskinputitens';

@Injectable({ providedIn: 'root' })
export class TaskInputService {

  private taskInput = new TaskInput();
  private componentsUtils: ComponentesUtils;
  private page = 1;
  private pageSize = 4;

  constructor(private apiCockpit: APISCockpit) {}

  async GetInfoTaskInput(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      this.taskInput = await this.apiCockpit.getDataInfoPaginated(API, this.CreateParams(itm, this.page, this.pageSize, null));
      this.page++;
      return this.taskInput;
    }
  }

  async GetInfoTaskInputWithCostGroup(itm: TaskItem, groupCostIds: Array<string>) {
    this.componentsUtils = new ComponentesUtils();
    if (typeof(itm?.companyid) !== 'undefined') {
      const filterComplexArray = new Array<FilterComplex>();
      groupCostIds.forEach(id => filterComplexArray.push(new FilterComplex('costGroupId', id.split('|')[2])))
      this.taskInput = await this.apiCockpit.getDataInfoPaginated(API, this.CreateParams(itm, this.page, this.pageSize,
                                                                                         this.componentsUtils.FilterEqualConcatenated(filterComplexArray)));
      this.page++;
      return this.taskInput;
    }
  }

  private CreateParams(taskItem: TaskItem, page: number, pageSize: number, filterComplex: string) :HttpParams{
    let params = new HttpParams();
    params = params.set('companyId', taskItem.companyid.toString());
    params = params.set('projectId', taskItem.projectid.toString());
    params = params.set('taskId', taskItem.taskid.toString());
    params = params.set('page', page.toString());
    params = params.set('pageSize', pageSize.toString());
    if(filterComplex != null && filterComplex && filterComplex?.length > 0) {
      params = params.set('$filter', filterComplex);
    }
    params = params.set('order','inputDescription');
    return params;
  }

  ResetPages() {
    this.page = 1;
  }
}
